import React from 'react'

import Spinner from '../../Spinner/spinner';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Checkbox } from '@mui/material';
import { IoIosArrowDown } from 'react-icons/io';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import UseAddGroup from '../hooks/useAddGroup';
import { ToastContainer } from 'react-toastify';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const AddGroup = () => {
const {
    id,
    navigate,
    handleContactChange,
    spinner,
    contactsList,
    addGroup,
    optionsWithSelectAll,
}=UseAddGroup()

    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle d-flex align-items-center'>
                            <ChevronLeftIcon sx={{ fontSize: "30px" }} className='cursor' onClick={() => navigate(-1)} /> {id ? 'Edit' : 'Add'}   Group
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={addGroup?.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Group    Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={addGroup.handleChange}
                                value={addGroup.values.name}
                            />
                            {addGroup.touched.name && addGroup.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addGroup.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label className="col-form-label">
                                Contacts*
                            </label>
                            <Autocomplete multiple className="w-100" id="checkboxes-tags-demo" options={optionsWithSelectAll}
                                value={optionsWithSelectAll.filter(option => addGroup?.values?.contact?.includes(option._id))}
                                onChange={handleContactChange} getOptionLabel={(option) => option?.name} size="small" disableCloseOnSelect
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }}
                                            checked={option._id === "select-all" ? addGroup?.values?.contact?.length === contactsList?.length : selected}
                                        />
                                        {option?.name}
                                    </li>
                                )}
                                
                                renderInput={(params) => (
                                    <TextField  {...params} label=" " style={{ color: "red" }} InputLabelProps={{ shrink: false }} sx={{height:"35px !important"}}/>
                                )}
                                
                                popupIcon={<IoIosArrowDown style={{ fontSize: "17px",fill: "black"}} />}
                                disableClearable
                                
                            />
                            {addGroup.touched.contact && addGroup.errors.contact ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addGroup.errors.contact}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="recipient-name" className="col-form-label">Description*</label>
                            <textarea className='form-control' name='description' onChange={addGroup.handleChange} value={addGroup.values.description} ></textarea>
                            {addGroup.touched.description && addGroup.errors.description ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addGroup.errors.description}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">{id ? 'Update' : 'Submit'}</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddGroup